import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureSinglePlanTranslationDictionary } from './feature-single-plan-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureSinglePlanTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      PRICE_TAX_DISCLAIMER:
        'Price includes any applicable Insurance Premium Tax or VAT and is subject to any inflation and tax rate changes.',
      SINGLE_PLAN_SALE_PAGE_SUBTITLE:
        'Your guarantee gives you repairs for manufacturing faults for {{ warrantyInMonths }} months. By adding extra protection to your appliance registration, you may avoid potentially expensive repair bills.',
      SINGLE_PLAN_SALE_PAGE_PROVIDED_BY:
        'Insurance provided by Domestic & General',
      SINGLE_PLAN_SALE_PAGE_WHATS_COVERED: `What's covered`,
      SINGLE_PLAN_SALE_PAGE_WHATS_NOT_COVERED: `What's not covered`,
      SINGLE_PLAN_SALE_PAGE_PLUS_YOU_GET: `Plus you'll get`,
      SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE: 'Protect your {{ applianceName }}',
      SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE: 'for {{ price }} a month',
      SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE_ONE_OFF: '{{ price }}',
      SINGLE_PLAN_SALE_PAGE_FOOTER_SUBTITLE:
        'No fixed-term contract, cancel anytime',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME_ALT:
        'Cancel online anytime (no need to call us)',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME:
        'No fixed-term contract',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_POLICY_DISCLAIMER:
        '*From 11am on 31st March 2026 to 11am on 28th April 2026. Discount applies for the first 2 months of the policy only. Available on selected online registrations (on some sites may only be available for existing customers). You can’t take out another policy under the promotion for the same item within 12 months of buying the original policy. We have the right to amend, end or withdraw this promotion before the end date if there are circumstances outside our control.',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_POLICY_DISCLAIMER_ALT:
        '*Applies for the first 3 months only. You can’t take out another policy for the same item within 12 months of buying the original policy. We have the right to amend, end or withdraw this promotion before the end date if there are circumstances outside our control.',
      SINGLE_PLAN_SALE_PAGE_CTA_REGISTER_ONLY: 'Register only',
      SINGLE_PLAN_SALE_PAGE_CTA_PURCHASE_PLAN: 'Yes, protect my appliance',
      SINGLE_PLAN_REVIEW_COVER_PAGE_TITLE: 'Review your cover',
      SINGLE_PLAN_REVIEW_COVER_PAGE_CTA_CONTINUE: 'Continue',
      SINGLE_PLAN_SALE_PAGE_TITLE:
        'Your guarantee has limits - add extra protection today',
      SINGLE_PLAN_SALE_PAGE_2MF_PROMO_BANNER:
        'Plus, get your first 2 months protection FREE*. Cancel anytime',
      SINGLE_PLAN_SALE_PAGE_2MF_PROMO_TABLE_BANNER:
        'Plus get your first 2 months protection FREE*',
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_TITLE: "You'll also get",
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_ACCESS:
        '24/7 access to make a claim online',
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_REPAIRS:
        'Repairs by approved engineers',
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_SUPPORT: 'Call centre support',
      SINGLE_PLAN_SALE_PAGE_EXCLUSION_PANEL_TITLE: 'Key Policy Exclusions',
      STEP_TITLE_EXTRA_COVER_OPTIONAL: 'Extra cover (optional)',
    },
    [LocaleId.English_Ireland]: {
      PRICE_TAX_DISCLAIMER:
        'Price includes any applicable Insurance Premium Tax or VAT and is subject to any inflation and tax rate changes.',
      SINGLE_PLAN_SALE_PAGE_SUBTITLE:
        'Your guarantee gives you repairs for manufacturing faults for {{ warrantyInMonths }} months. By adding extra protection to your appliance registration, you may avoid potentially expensive repair bills.',
      SINGLE_PLAN_SALE_PAGE_PROVIDED_BY:
        'Insurance provided by Domestic & General',
      SINGLE_PLAN_SALE_PAGE_WHATS_COVERED: `What's covered`,
      SINGLE_PLAN_SALE_PAGE_WHATS_NOT_COVERED: `What's not covered`,
      SINGLE_PLAN_SALE_PAGE_PLUS_YOU_GET: `Plus you'll get`,
      SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE: 'Protect your {{ applianceName }}',
      SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE: 'for {{ price }} a month',
      SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE_ONE_OFF: '{{ price }}',
      SINGLE_PLAN_SALE_PAGE_FOOTER_SUBTITLE:
        'No fixed-term contract, cancel anytime',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME_ALT:
        'Cancel online anytime (no need to call us)',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME:
        'No fixed-term contract, cancel anytime',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_POLICY_DISCLAIMER:
        '*From 11am on 31st March 2026 to 11am on 28th April 2026. Discount applies for the first 2 months of the policy only. Available on selected online registrations (on some sites may only be available for existing customers). You can’t take out another policy under the promotion for the same item within 12 months of buying the original policy. We have the right to amend, end or withdraw this promotion before the end date if there are circumstances outside our control.',
      PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_POLICY_DISCLAIMER_ALT:
        '*Applies for the first 3 months only. You can’t take out another policy for the same item within 12 months of buying the original policy. We have the right to amend, end or withdraw this promotion before the end date if there are circumstances outside our control.',
      SINGLE_PLAN_SALE_PAGE_CTA_REGISTER_ONLY: 'Register only',
      SINGLE_PLAN_SALE_PAGE_CTA_PURCHASE_PLAN: 'Yes, protect my appliance',
      SINGLE_PLAN_REVIEW_COVER_PAGE_TITLE: 'Review your cover',
      SINGLE_PLAN_REVIEW_COVER_PAGE_CTA_CONTINUE: 'Continue',
      SINGLE_PLAN_SALE_PAGE_TITLE:
        'Your guarantee has limits - add extra protection today',
      SINGLE_PLAN_SALE_PAGE_2MF_PROMO_BANNER:
        'Plus, get your first 2 months protection FREE*. Cancel anytime',
      SINGLE_PLAN_SALE_PAGE_2MF_PROMO_TABLE_BANNER:
        'Plus get your first 2 months protection FREE*',
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_ACCESS:
        '24/7 access to make a claim online',
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_REPAIRS:
        'Repairs by approved engineers',
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_TITLE: "You'll also get",
      SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_SUPPORT: 'Call centre support',
      SINGLE_PLAN_SALE_PAGE_EXCLUSION_PANEL_TITLE: 'Key Policy Exclusions',
      STEP_TITLE_EXTRA_COVER_OPTIONAL: 'Extra cover (optional)',
    },
  };
